import {JsonObject, JsonProperty} from 'json2typescript';
import {TSMap} from 'typescript-map';
import {TSStringToStringMapConverter} from '../../customJsonConverters/TSStringToStringMapConverter';


@JsonObject('ExternalLink')
export class ExternalLink {

  @JsonProperty('links',TSStringToStringMapConverter)
  links:TSMap<string,string> = new TSMap();

  @JsonProperty('texts',TSStringToStringMapConverter)
  texts:TSMap<string,string> = new TSMap();

  @JsonProperty('descriptions',TSStringToStringMapConverter)
  descriptions:TSMap<string,string> = new TSMap();

  // TODO: We probably don't need these properties. Remove upon confirmation
  @JsonProperty('cssClass',String,true)
  cssClass = '';

  @JsonProperty('uid',String,true)
  uid = '';


    constructor() {
    }

}
